import { forwardRef, useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { DisplayListPagination, DisplaySearchCriteria, PeriodSelectionWithCustom } from '../../../components/TapUi';
import Loader from '../../../components/ui/Loader/Loader';
import TapSelect from '../../../components/ui/TapSelect';
import ApplicationLayout from '../../../layouts/ApplicationLayout';
import HttpAPICall from '../../../services/HttpAPICall';
import { HRM_API_BASE_URL_2 } from '../../../services/TapApiUrls';
import TapHelper from '../../../services/TapHelper';
import TapIcon from '../../../services/TapIcon';
import PageHeader from '../../includes/PageHeader';
import DownloadFile from '../../../services/DownloadFile';
import { toast } from 'react-toastify';
import swal from "sweetalert";
import moment from 'moment';
import InputEmployeeSearch from '../../includes/ui/InputEmployeeSearch';
const AttendenceReport  =   forwardRef((props) => {
    const criteriaRef =useRef()

    let initListData = {
        loading                                     :     false,
        show                                        :     false,
        items                                       :     [],
        meta                                        :     null,
        page                                        :     1
    };

    let initFormData = {
        show                                        :     true,
        per_page                                    :     5,
        form_data_loaded                            :     false,
        loading                                     :     false,
        downloading                                 :     false,
        periods                                     :     [],
        date_range                                  :     null,
        date_range_start                            :     null,
        date_range_end                              :     null,
        sites                                       :     [],
        search_site_ids                             :     [],
        search_employee_code              :     '',
        search_employee_ids                         :     [],
        search_employee_type_ids                    :     [],
        search_designation_ids                      :     [],
        search_division_ids                         :     [],
        employeeTypes                               :     [],
        allStatus                                   :     [],
        designation                                 :     [],
        division                                    :     [],
        status_search                               :     [],
        manager_data                                :   {},
        search_reporting_manager                    :   "",

    };
              
    let formDataLabel = {
        date_range                                  :     'Date Range : ',
        search_site_ids                             :     'Sites : ',
        search_employee_code                        :     'Employee ID  : ',
        search_employee_type_ids                    :     "Employee Type : ",
        search_designation_ids                      :     "Designation : ",
        search_division_ids                         :     "Department : ",
        search_employee_ids                         :     'Employees : ',
        status_search                               :     "Status : ",
        search_reporting_manager                    :     "Reporting Manager : "

    };

    const access_token          =     useSelector(state => state.auth.access_token);
    const all_periods           =     useSelector(state => state.app.all_periods ? state.app.all_periods   : []);
    const user_sites            =     useSelector(state => state.app.user_sites ? state.app.user_sites     : []);
    const [criteriaHeight, setCriteriaHeight] =useState(0)

    const [attendenceData, setAttendenceData]         =    useState({ ...initListData });
    const [formData, setFormData]                     =    useState({ ...initFormData });
    const [searchedElems, setSearchedElems]           =    useState([]);
    const [searchedEmployees , setSearchedEmployees]  =    useState ([])
    let attendenceReportUrl             = HRM_API_BASE_URL_2 + "/report/employee_attendance";
    const formDataUrl                   = HRM_API_BASE_URL_2 + '/employee/add_form_data';

    useEffect(() => {
        toggleFilterForm(true);
    }, []);

     const updateCriteriaHeight = () => {
        if (criteriaRef.current) {
            const height = criteriaRef.current.offsetHeight;
            if (criteriaHeight !== height) {
                setCriteriaHeight(height)
            }
        }
    };
    useEffect(() => {
        updateCriteriaHeight()

        if (formData.show && !formData.form_data_loaded) {
            loadFormData();
        }
    }, [formData.show]);

    const toggleFilterForm                =  (show)     => {
        setFormData(pd => ({ ...pd, show: show }))
        if (document.getElementById('pageTbl')) {
            document.getElementById('pageTbl').scroll({ top: 0, behavior: 'smooth' });
        }
    }

    const handleOnSelect = (selectVal, key) => {
        if (!selectVal) {
            setFormData(pre => ({
                ...pre, [key]: []
            }));
            return; 
        }

        const data = Array.isArray(selectVal) ? selectVal.map(d => d.value) : [selectVal.value];
        setFormData(pre => ({
            ...pre, [key]: data
        }));
    };


    const loadFormData                    =  ()         => {
        setFormData(pre => ({ ...pre, loading: true }));
        HttpAPICall.withAthorization("GET", formDataUrl, access_token, { type: 'config' }, {}, (resp) => {
            const { status, employee_type, designation, division } = resp.data;
            
            setFormData(pre => ({
                ...pre,
                 form_data_loaded   :   true,
                 loading            :   false,
                 periods            :   [...all_periods, { key: 'custom', display: 'Custom Date Range' }],
                 sites              :   user_sites.map((s) => { return { value: s.id, label: `${s.site_name} (${s.site_code})` } }),
                 allStatus          :   status && status.length > 0 ? status.map((s) => ({ value: s.key, label: s.name })) : [],
                 employeeTypes      :   employee_type && employee_type.length > 0 ? employee_type.map((et) => ({ value: et.id, label: et.name })) : [],
                 designation        :   designation && designation.length > 0 ? designation.map((des) => ({ value: des.id, label: des.name })) : [],
                 division           :   division && division.length > 0 ? division.map((div) => ({ value: div.id, label: div.name })) : []
            }))
        }).then(() => setFormData(pre => ({ ...pre, loading: false })));
    }

    const closeReport = () => props.history.push({ pathname: `/report` })
    const submitSearchFormHandler         =  (e)        => {
        e.preventDefault();
        toggleFilterForm(false);
        let searchedElems = [];
        let searchParams = {};
        Object.keys(formData).map((key) => {
            let label = formDataLabel[key];
            let value = formData[key];
            
            if (value && value.length > 0) {
                searchParams[key] = value;
                if (label) {
                    
                    let show_val = value;
                    if (key == 'search_site_ids') {
                        show_val = formData.sites.filter((s) => value.includes(s.value)).map(s => s.label).join(', ');
                    }
                    if (key == 'date_range') {
                        let start_range = moment(formData.date_range_start).format('DD-MMM-YYYY');
                        let end_range = moment(formData.date_range_end).format('DD-MMM-YYYY')
                        let display_custom = `Custom Date Range (${start_range} - ${end_range})`
                        show_val = formData.periods.filter((s) => value.includes(s.key)).map(s => s.display_with_date ? s.display_with_date : display_custom);
                    }
                    if(key == 'search_employee_code') {
                        show_val            =  formData.search_employee_code   ;
                    }
                    if (key === "search_employee_type_ids") {
                        show_val = formData.employeeTypes.filter((s) => value.includes(s.value)).map((s) => s.label)
                        .join(", ");
                    }
                    if (key === "search_designation_ids") {
                        show_val = formData.designation.filter((s) => value.includes(s.value)).map((s) => s.label)
                        .join(", ");
                    }
                    if (key === "search_division_ids") {
                        show_val = formData.division.filter((s) => value.includes(s.value)).map((s) => s.label)
                        .join(", ");
                    }
                    if(key == 'search_employee_ids') {
                        show_val            =   searchedEmployees ? searchedEmployees.map(s => s.label).join(', ') : '';
                    }
                    if (key == "search_reporting_manager") {
                        show_val = formData.manager_data?.label;
                    }
                    if (key == "status_search") {
                        show_val = formData.allStatus.filter((s) => value.includes(s.value)).map((s) => s.label)       
                    }
                    searchedElems.push(label + `<b>${show_val}</b>`);
                }
            }
        });
        setSearchedElems(searchedElems);
        loadItemsData(1);
    }
    const loadItemsData                   =  (page = 1) => {
        setAttendenceData(pd => ({ ...pd, show: true, loading: true, page: page }));
        let params = {
            action: 'data',
            page: page,
            ...TapHelper.pick(formData, ['date_range', 'date_range_start', 'date_range_end', 'search_site_ids',"search_employee_ids","search_employee_type_ids","search_designation_ids","search_division_ids","status_search",'search_employee_code','search_reporting_manager'])
        };
        HttpAPICall.withAthorization('GET', attendenceReportUrl, access_token, params, {}, (response) => {
            let respData   =  response.data;
            let meta       =  TapHelper.pick(respData, ['from', 'to', 'total', 'last_page', 'per_page', 'current_page']);
            setAttendenceData(pd => ({ ...pd, items: respData.data, meta: meta, sites: response.data.sites, }));
        }).then(() => {
            setAttendenceData(pd => ({ ...pd, loading: false }));
        });
      
    }
   const  activityExceldownload           =   ()  =>  {
        swal({
            title: "Download",
            text: "The download will be for trailing three months period, in case you want a different criteria then please use search button before downloading.",
            icon: "warning",
            // dangerMode: true,
            buttons: ["No", "Yes"],
        })
            .then(willDelete => {
                if (willDelete) {
                    reportDownloadHandler()
                }
            });
    }


    const reportDownloadHandler           =  ()         => {
        const paramsFormData  =   {...TapHelper.pick(formData, ['date_range', 'date_range_start', 'date_range_end', 'search_site_ids',"search_employee_ids","search_employee_type_ids","search_designation_ids","search_division_ids","status_search",'search_employee_code','search_reporting_manager'])};
        let params = {
            ...paramsFormData,
            action: 'download',
            date_range : paramsFormData.date_range ? paramsFormData.date_range : 'current_month',
        };
        setAttendenceData(pd => ({ ...pd, downloading: true }));
        HttpAPICall.withAthorization('GET', attendenceReportUrl, access_token, params, {}, (response) => {
            DownloadFile.file(response.data.file_path)
            toast.success('File Downloaded Successfully', {position: toast.POSITION.TOP_RIGHT})
        }).then(() => {
            setAttendenceData(pd => ({ ...pd, downloading: false }));
        }).catch((err) => {
            toast.error(err.response?.data?.message, {position: toast.POSITION.TOP_CENTER})
        });
    }
    const formInputHandler = (e, afterCallbackFn = null) => {
        const { name, value, type } = e.target;
        const newValue = type === 'number' ? (value ? Number(value) : value) : value;
    
        setFormData(prevState => ({
            ...prevState,
            [name]: newValue
        }));
    
        if (afterCallbackFn) {
            afterCallbackFn();
        }
    };
    

    const filterFormJsx                   =  ()         => {
        return <form onSubmit={submitSearchFormHandler} className='py-3'>
            <div className="row my-3">
                <label className="col-sm-3 col-form-label text-end">Employee ID</label>
                <div className="col-sm-6">
                    <input
                        name="search_employee_code"
                        type="text"
                        value={formData.search_employee_code}
                        onChange={formInputHandler}
                        className="form-control form-control-sm"
                        autoComplete="off"
                        placeholder="Search Employee id"
                    />
                </div>
            </div>
              <div className="row my-3">
                <label className="col-sm-3 col-form-label text-end ">
                    Search Employee
                </label>
                <div className="col-sm-6">
                    <InputEmployeeSearch
                        changeEvent={(selectedOption) => {
                            // tapSelectChange(selectedOption, 'formData', 'search_employee_ids');
                            setFormData({...formData , search_employee_ids: selectedOption.length > 0 ? selectedOption.map(o => o.value) : [] })
                            setSearchedEmployees(selectedOption && selectedOption.length > 0 ? selectedOption : [])
                        }}
                        isMulti={true}
                        containerHeight="30px"
                        fontSize="93%"
                        placeholder="Select Employee"
                        value={searchedEmployees.length > 0 ? searchedEmployees.map(a => { a.label = a.label; return a; }) : []}
                    />
                </div>
            </div>
            <div className="row my-3">
                <label className="col-sm-3 col-form-label text-end">Site Name</label>
                <div className="col-sm-6">
                    <TapSelect
                        changeEvent={o => setFormData(d => ({ ...d, search_site_ids: o.map(e => e.value) }))}
                        placeholder="Select Sites"
                        isClearable={true}
                        options={formData.sites}
                        value={formData.sites.filter(s => formData.search_site_ids.includes(s.value))}
                        isMulti={true}
                        isSearchable={true}
                        containerHeight="30px"
                        fontSize="93%"
                    />
                </div>
            </div>
            <div className="row my-3">
                <label className="col-sm-3 col-form-label text-end ">Employee Type</label>
                <div className="col-sm-6">
                    <TapSelect
                        options={formData.employeeTypes}
                        changeEvent={(selectedOption) => {
                            handleOnSelect(selectedOption, "search_employee_type_ids");
                        }}
                        isSearchable={true}
                        isClearable={true}
                        isMulti={true}
                        menuPlacement="bottom"
                        value={formData.employeeTypes.filter((s) => formData.search_employee_type_ids?.includes(s.value))}
                        placeholder="Select Employee Type"
                        containerHeight="30px"
                        fontSize="93%"
                    />
                </div>
            </div>
            <div className="row my-3">
                <label className="col-sm-3 col-form-label text-end ">Designation</label>
                <div className="col-sm-6">
                    <TapSelect
                        options={formData.designation}
                        changeEvent={(selectedOption) => {
                            handleOnSelect(selectedOption, "search_designation_ids");
                        }}
                        isSearchable={true}
                        isClearable={true}
                        isMulti={true}
                        value={formData.designation.filter((s) => formData.search_designation_ids?.includes(s.value)
                        )}
                        placeholder="Select Designation"
                        containerHeight="30px"
                        fontSize="93%"
                    />
                </div>

            </div>
            <div className="row my-3">
                <label  className="col-sm-3 col-form-label text-end ">
                    Department
                </label>
                <div className="col-sm-6">
                    <TapSelect
                        options={formData.division}
                        changeEvent={(selectedOption) => {
                            handleOnSelect(selectedOption, "search_division_ids");
                        }}
                        isSearchable={true}
                        isClearable={true}
                        isMulti={true}
                        value={formData.division.filter((s) => formData.search_division_ids?.includes(s.value)
                        )}
                        placeholder="Select Department"
                        containerHeight="30px"
                        fontSize="93%"
                    />
                </div>
            </div>
            <div className="row my-3">
                <label className="col-sm-3 col-form-label text-end">Reporting Manager</label>
                <div className="col-sm-6">
                    <InputEmployeeSearch
                        placeholder="Search"
                        changeEvent={(selectedOption) => {
                            setFormData(pre => ({
                                ...pre,
                                search_reporting_manager: selectedOption?.value || "",
                                manager_data: selectedOption || {}
                            }));
                        }}
                        containerHeight="30px"
                        fontSize="93%"
                        value={
                            formData.search_reporting_manager ? formData.manager_data : ''
                        }
                    />
                </div>
            </div>
                <div className="row my-3">
                <label className="col-sm-3 col-form-label text-end ">
                    Status
                </label>
                
                <div className="col-sm-6">
                    <TapSelect
                        options={formData.allStatus}
                        changeEvent={(selectedOption) => {
                            handleOnSelect(selectedOption, "status_search");
                        }}
                        isSearchable={true}
                        isClearable={true}
                        menuPlacement="bottom"
                        value={formData.allStatus.filter((s) => formData.status_search?.includes(s.value))} 
                        placeholder="Select Status"
                        containerHeight="30px"
                        fontSize="93%"
                    />

                </div>
            </div>
          
             <div className="row my-3">
                <label className="col-sm-3 col-form-label-sm text-end require">Transaction Period</label>
                <div className="col-sm-6">
                    <PeriodSelectionWithCustom
                        periods={formData.periods ? formData.periods : []}
                        className="form-control-sm"
                        onSelectPeriod={(period, startDate, endDate) => {
                            setFormData(d => ({
                                ...d,
                                date_range: period,
                                date_range_start: startDate ? startDate : null,
                                date_range_end: endDate ? endDate : null
                            }))
                        }}
                        containerHeight="30px"
                        fontSize="93%"
                        required={true}
                        value={formData.date_range}
                        startDate={formData.date_range_start}
                        endDate={formData.date_range_end}
                    />
                </div>
            </div>
            <div className="row my-4  border-bottom">
                <div className="pb-3 col-sm-9 text-end">
                    <div className='d-flex justify-content-end align-items-center gap-2'>
                        <button type="submit" className="btn btn-primary px-4">Show Report</button>
                    </div>
                </div>
            </div>
        </form>
    }

    const voucherListJsx                  =  ()         => {
        return <>
         <div ref={criteriaRef}
                style={{
                    position: 'sticky',
                    top: 0,
                    background: 'white',
                }}>
            <DisplaySearchCriteria searchedElems={searchedElems} />
            </div>
            <table className="table table-sm table-bordered align-middle bg-white">
                <thead className="align-middle table-secondary"  style={{
                    top: `${criteriaHeight}px`,
                    position: 'sticky',
                }}>
                    <tr className='text-center'>
                        <th style={{ width: "25%" }}>Employee Name</th>
                        <th style={{ width: "15%" }}>Code</th>
                        <th style={{ width: "20%" }}>Current Site</th>
                        <th style={{ width: "10%" }}>Total Present</th>
                        <th style={{ width: "10%" }}>Total Absent</th>
                        <th style={{ width: "10%" }}>Total Leave</th>
                        <th style={{ width: "10%" }}>Total Holidays / Weekly Off</th>
                    </tr>
                </thead>
                <tbody>
                    {attendenceData.loading
                        ? <tr><td className='text-center' colSpan={9}><Loader /></td></tr>
                        : ((attendenceData.items && attendenceData.items.length > 0)
                            ? attendenceData.items.map((item, index) => {
                                return <tr key={index}>
                                    <td>{item.name || "-"}<br /></td>
                                    <td>
                                        {item.employee_code || "-"}
                                    </td>
                                    <td>
                                        {item?.site_name || "-"}
                                    </td>
                                    <td>
                                        {item?.total_present || "-"}
                                    </td>
                                    <td>
                                        {item?.total_absent || "-"}
                                    </td>
                                    <td>
                                        {item?.total_leave || "-"}
                                    </td>
                                    <td>
                                        {item?.total_weekoff || "-"}
                                    </td>
                                   
                                </tr>
                            })
                            : <tr><td className='text-center' colSpan={8}>No Records Found</td></tr>)
                    }
                </tbody>
            </table>
            <DisplayListPagination meta={attendenceData.meta} onPageChange={(e) => loadItemsData(e.selected + 1)} />
        </>
    }

    const topRightHeaderJsx               =  ()         => {
        return <>
            <div className="text-end mt-2">
                <button type="button" disabled={attendenceData.downloading || attendenceData.loading || formData.loading} className="btn btn-secondary" onClick={() => toggleFilterForm(!formData.show)} >
                    Change Filter
                </button>
                {attendenceData.show && <button type="button" disabled={attendenceData.downloading || attendenceData.loading || formData.loading} className="btn btn-secondary" onClick={activityExceldownload}>
                    <TapIcon.FontAwesomeIcon icon={TapIcon.faDownload} />
                    {attendenceData.downloading && <TapIcon.FontAwesomeIcon icon={TapIcon.faSyncAlt} className="fa-spin ms-2" />}
                </button>}
                <button type="button" className="btn btn-secondary mx-1" onClick={closeReport}>
                    <TapIcon.imageIcon icon={TapIcon.CloseIcon} className="img-fluid" alt="Close requisition" />
                </button>
            </div>
        </>
    }

    return <ApplicationLayout>
        <PageHeader title="Employee Attendence Report" name="Employee Attendence Report" rightTopHeadingJsx={topRightHeaderJsx()} />
        <div className="container-fluid pl5">
            <div className="page_containt row">
                <div id="pageTbl" className="pageTbl col-sm-12 pb-3">
                    <div className={["bg-white", formData.show ? 'tbShow' : 'tbHide'].join(" ")} >
                        {formData.loading ? <Loader /> : filterFormJsx()}
                    </div>
                    {attendenceData.show && voucherListJsx()}
                </div>
            </div>
        </div>
    </ApplicationLayout>

});

export default AttendenceReport;